import Vue from 'vue'
import Router from 'vue-router'

// import store from '../storages'
import ContentVue from '../components/main/ContentVue.vue'
import AuthorizationVue from '../components/auth/AuthorizationVue.vue'

Vue.use(Router)

let _mode = (process.env.VUE_APP_ROUTER_MODE !== undefined) ? process.env.VUE_APP_ROUTER_MODE : 'hash'

const router = new Router({
  routes: [
    {
      name: 'main',
      path: '/',
      component: ContentVue
    },
    {
      name: 'login',
      path: '/login',
      component: AuthorizationVue
    },
    {
      name: 'detail',
      path: '/:pk',
      component: ContentVue
    }
  ],
  mode: _mode
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js